import * as React from 'react';
import * as Styled from './modal.styled';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  shouldCloseOnOverlayClick?: boolean;
}

/**
 * @useClient
 */
export const Modal = React.memo(function Modal({
  children,
  isOpen,
  onClose,
  className,
  shouldCloseOnOverlayClick = true
}: React.PropsWithChildren<ModalProps>) {
  return <Styled.Modal className={className} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}>
      {children}
    </Styled.Modal>;
});